//I GUESS THIS SHOULD BE IN THE PLUGIN - @TODO
let accordion = jQuery('.mortar-accordion__title a')

accordion.on('click', function (e) {

    e.preventDefault()

    let thisEl = jQuery(this),
        thisParent = thisEl.parent()

    thisParent.toggleClass('open')

})

if(jQuery('.mortar-accordion__wrap').length > 0){

    var accordions = jQuery('.mortar-accordion__wrap .mortar-accordion__title').children();
    accordions.each(function() {
        jQuery(this).attr('id',jQuery(this).attr('href').replace('#', ''));
    })

}



jQuery('.mortar-tabs__list li:first-child a').addClass('selected')

jQuery('.mortar-tabs__list a').on('click', function(e) {

    e.preventDefault()

    let parentLi = jQuery(this).parent()
    let parentLiIndex = parentLi.index()
    let wrapper = jQuery(this).parents('.mortar-tabs')

    wrapper.find('.mortar-tabs__list a').removeClass('selected')
    jQuery(this).addClass('selected')

    wrapper.find('.mortar-tabs__content').hide().eq(parentLiIndex).show()

});
